export const locationIQToken = process.env.REACT_APP_LOCATIONIQ_ACCESS_TOKEN;
export const LOCATIONIQ_BASE_STATIC_URL = "https://maps.locationiq.com/v3/staticmap";
const LOCATIONIQ_BASE_REVERSE_URL = "https://us1.locationiq.com/v1/reverse.php";

const cache = {};

class LocationService {

    static async reverseGeocode(lat, lon) {
        const key = `${lat},${lon}`;

        if (cache[key]) return cache[key];

        try {
            const res = await fetch(
                `${LOCATIONIQ_BASE_REVERSE_URL}?key=${locationIQToken}&lat=${lat}&lon=${lon}&format=json`
            );

            if (!res.ok) {
                console.error(`rrw002: LocationIQ Error: ${res.status} ${res.statusText}`);
                return `${lat}, ${lon}`;
            }

            const data = await res.json();

            const address = data?.display_name || `${lat}, ${lon}`;

            cache[key] = address;
            return address;
        } catch (e) {
            console.error("Network/Parsing Error in LocationService:", e);
            return `${lat}, ${lon}`;
        }
    }
}

export default LocationService;